/* eslint-disable react/no-danger */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import React from 'react';
import { fetchCompanyAds } from '../../CompanyAds/companyAdsFunctions';
import InlineAd from '../../CompanyAds/InlineAd/InlineAd';
import { TopicShape } from '../../Includes/Shapes/Topic';
import { stripAdPlaceholderText } from '../../../utilities/helperFunctions';
import './EditorialContentSection.scss';
import { PageContext } from '../../../contexts/ContextCreator';

export const WRAPPED_AD = '{{{COMPANY_AD_EMBEDED}}}';
export const STANDALONE_AD = '{{{COMPANY_AD_STANDALONE}}}';

const injectContent = (content) => ({ __html: content });

export default class EditorialContentSection extends React.PureComponent {
    constructor(props) {
        super(props);
        const HAS_WRAPPED_AD = this.props.content.includes(WRAPPED_AD);
        const HAS_STANDALONE_AD = this.props.content.includes(STANDALONE_AD);

        const initialContent = stripAdPlaceholderText(this.props.content);

        this.state = {
            HAS_WRAPPED_AD,
            HAS_STANDALONE_AD,
            content: (
                <div dangerouslySetInnerHTML={injectContent(initialContent)} />
            ),
        };
    }

    componentDidMount() {
        const { HAS_STANDALONE_AD, HAS_WRAPPED_AD } = this.state;

        if (HAS_WRAPPED_AD) this.renderContent(WRAPPED_AD);

        if (HAS_STANDALONE_AD) this.renderContent(STANDALONE_AD);
    }

    renderContent = async (type) => {
        const ad = await this.getCompanyAd(type);
        const splitContent = this.props.content.split(type);
        const content1 = (
            <span dangerouslySetInnerHTML={injectContent(splitContent[0])} />
        );
        const content2 = (
            <span dangerouslySetInnerHTML={injectContent(splitContent[1])} />
        );
        const content = [content1, ad, content2];
        this.setState({ content });
    };

    getCompanyAd = async (type) => {
        const { isPaid } = this.props;

        if (isPaid) return null;

        let styleClass = '';
        if (type === WRAPPED_AD) {
            styleClass = 'wrapped';
        }

        try {
            const res = await fetchCompanyAds();
            return <InlineAd className={styleClass} {...res} />;
        } catch (e) {
            console.error(e);
            throw e;
        }
    };

    splitWords = (text, numWords) => {
        const words = text.split(' ');
        let part1 = '';
        let part2 = '';
        words.forEach((word, idx) => {
            if (idx < numWords) {
                part1 += ` ${word}`;
            } else {
                part2 += ` ${word}`;
            }
        });
        return [part1, part2];
    };

    render() {
        const { content } = this.state;
        const [part1, part2] = this.splitWords(
            content.props.dangerouslySetInnerHTML.__html,
            190
        );
        return (
            <div className="component-EditorialContent-EditorialContentSection">
                <div className="editorialContentDisplay fr-element fr-view">
                    {this.context.leadInLogin && (
                        <>
                            <div>
                                <span
                                    dangerouslySetInnerHTML={injectContent(
                                        part1
                                    )}
                                />
                            </div>
                            <div className="editorialContentWalled">
                                <span
                                    dangerouslySetInnerHTML={injectContent(
                                        part2
                                    )}
                                />
                            </div>
                        </>
                    )}
                    {!this.context.leadInLogin && content}
                </div>
            </div>
        );
    }
}

EditorialContentSection.contextType = PageContext;

EditorialContentSection.propTypes = {
    /**
     *  the more text section text
     * */
    moreText: PropTypes.string,
    /**
     * current topic
     * */
    topic: TopicShape,
    /**
     * content is paid by company
     * */
    isPaid: PropTypes.bool,
    /**
     * text, article content
     * */
    content: PropTypes.string.isRequired,
};

EditorialContentSection.defaultProps = {
    moreText: 'More Articles in',
    topic: {
        name: 'Test',
        url: '/test',
    },
    isPaid: false,
};
